import { defineCatalogue } from '../../i18n';

/** `SpendChart`'s own copy -- self-contained like `admins/messages.ts`, not
 *  the global catalogue and not `TenantDetail`'s inline one, since nothing
 *  outside this component needs any of these keys. */
export const spendCatalogue = defineCatalogue(
  {
    'chart.title': 'Gastos diários',
    'chart.subtitle':
      'Últimos {days} dias · o que a organização pagou e o que o provedor custou, dia a dia',
    'chart.legend.margin': 'Margem',
    'chart.legend.cost': 'Custo do provedor',
    'chart.legend.loss': 'Prejuízo',
    'chart.toggle.table': 'Ver como tabela',
    'chart.toggle.chart': 'Ver como gráfico',
    'chart.empty': 'Nenhum gasto neste período.',
    'chart.error': 'Não foi possível carregar os gastos.',
    // `{days}`/`{negativeDays}` arrive pre-pluralised ("1 dia"/"2 dias") --
    // see `i18n/format.ts`'s `days()` -- so this never has to branch on count.
    'chart.summary':
      '{days}, custo médio de {avgCost} créditos por dia, {negativeDays} com margem negativa.',
    'chart.foot.avgCost': 'Custo médio por dia',
    'chart.foot.maxCost': 'Maior custo do provedor',
    'chart.foot.maxCost.value': '{value} · {day}',
    'chart.foot.negativeDays': 'Dias com margem negativa',
    'chart.foot.negativeDays.none': 'Nenhum',
    'chart.foot.negativeDays.value': '{count} ({days})',
    'table.day': 'Dia',
    'table.cost': 'Custo (provedor)',
    'table.margin': 'Margem',
    'tooltip.billed': 'Cobrado',
    'tooltip.cost': 'Custo do provedor',
    'tooltip.margin': 'Margem',
    'tooltip.inputTokens': 'Tokens de entrada',
    'tooltip.outputTokens': 'Tokens de saída',
    'tooltip.calls': 'Chamadas',
    'tooltip.fencedHint':
      'Administradores não podem ver dentro de uma organização, então isto permanece em branco.',
  },
  {
    'chart.title': 'Daily spend',
    'chart.subtitle':
      'Last {days} days · what the organisation paid and what the provider cost, day by day',
    'chart.legend.margin': 'Margin',
    'chart.legend.cost': 'Provider cost',
    'chart.legend.loss': 'Loss',
    'chart.toggle.table': 'View as table',
    'chart.toggle.chart': 'View as chart',
    'chart.empty': 'No spend in this period.',
    'chart.error': "Could not load this organisation's spend.",
    'chart.summary':
      '{days}, average cost of {avgCost} credits per day, {negativeDays} with a negative margin.',
    'chart.foot.avgCost': 'Average cost per day',
    'chart.foot.maxCost': 'Highest provider cost',
    'chart.foot.maxCost.value': '{value} · {day}',
    'chart.foot.negativeDays': 'Days with a negative margin',
    'chart.foot.negativeDays.none': 'None',
    'chart.foot.negativeDays.value': '{count} ({days})',
    'table.day': 'Day',
    'table.cost': 'Cost (provider)',
    'table.margin': 'Margin',
    'tooltip.billed': 'Billed',
    'tooltip.cost': 'Provider cost',
    'tooltip.margin': 'Margin',
    'tooltip.inputTokens': 'Input tokens',
    'tooltip.outputTokens': 'Output tokens',
    'tooltip.calls': 'Calls',
    'tooltip.fencedHint': 'Administrators cannot see inside an organisation, so this stays blank.',
  },
);

export const sc = spendCatalogue.t;
